import { atom } from "recoil";
const announcementState = atom({
  key: "announcement",
  default: ''
});

export { announcementState };